import { TucanoAdminUI } from "../../types";
import { TauiServices } from "../../types/structure";

export const getCurrentPermissionRG = async (taui: TucanoAdminUI) =>
  taui.callApi<{
    result: string[];
  }>("GET", TauiServices.identity, "/oauth/current");
